import { EventEmitter, Injectable } from "@angular/core";


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  public static readonly sharedInstance = new StorageService()

  readonly rawChanges = new EventEmitter<{ key: string, value: string | null }>()

  storage: Storage =  localStorage

  constructor() { }

  isKeyDefined(key: string): boolean {
    return this.storage.getItem(key) != null
  }

  getItemRaw(key: string): string | null {
    return this.storage.getItem(key)
  }

  getItemJson(key: string): any | null {
    const raw = this.getItemRaw(key)
    if (raw) {
      return JSON.parse(raw)
    }
    return null
  }

  setItemRaw(key: string, value: string | null) {
    if (value != null) {
      this.storage.setItem(key, value)
    }
    else {
      this.storage.removeItem(key)
    }
    this.rawChanges.emit({
      key: key,
      value: value
    })
  }

  setItemJson(key: string, value: any) {
    if (value != null) {
      this.storage.setItem(key, JSON.stringify(value))
    }
    else {
      this.storage.removeItem(key)
    }
    this.rawChanges.emit({
      key: key,
      value: value
    })
  }

  setItem<T>(key: string, value: T) {
    this.setItemJson(key, value)
  }

  getItem<T>(key: string) {
    const parsed = this.getItemJson(key)
    if (parsed) {
      return parsed as T
    }
    return null
  }
}
